<template>
  <div class="question-add">
    <p class="title">{{ titleMsg }}</p>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="groupForm"
      ref="groupForm"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="所属小班："
            prop="smallClassId"
            v-if="isSamllClass"
          >
            <el-select
              class="select-content"
              v-model="groupForm.smallClassId"
              placeholder="请选择所属小班"
              :disabled="onlyLook"
            >
              <el-option
                v-for="(item, i) in smallClassNameList"
                :key="i"
                :label="item.classChildName"
                :value="item.uuid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="班组名称：" prop="groupName">
            <el-input
              v-model="groupForm.groupName"
              placeholder="请输入班组名称"
              :disabled="onlyLook"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- <el-row>
        <el-col>
          <el-form-item label="班组组长：" prop="leaderUserName">
            <el-input
              readonly
              v-model="groupForm.leaderUserName"
              placeholder="请从下方列表中选择一个成员作为组长"
              :disabled="onlyLook"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-row style="margin-top: 28px" v-show="!onlyLook">
        <el-col :span="10" class="right-wrap" style="float: right">
          <div class="btn-div">
            <el-checkbox
              :disabled="dragDisabled"
              v-model="dragaable"
              class="drag-box mr16"
              >拖拽排序</el-checkbox
            >
            <el-button
              class="mr16"
              :disabled="userIds.length == 0"
              size="small"
              @click="deleteGroupUsers"
              >批量移除</el-button
            >
            <el-button type="primary" size="small" @click="groupUserManage"
              >组员管理</el-button
            >
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="组员列表：">
            <Table
              :class="{ 'list-drag': dragaable }"
              :data="groupForm.groupUserList"
              @selection-change="selectChange"
              @setLeaderUser="setLeaderUser"
              @deleteLeaderUser="deleteLeaderUser"
              row-key="enrollId"
              :onlyLook="onlyLook"
              :isConvene="isConvene"
            ></Table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="dialog-footer" label-width="0">
            <el-button @click="resetForm" v-show="!onlyLook">重置</el-button>
            <!-- <el-button @click="$router.back()">返回</el-button> -->
            <back-button :floatLeft="false"/>
            <el-button type="primary" @click="submit" v-show="!onlyLook"
              >提交</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <UserManage :smallClassId="this.groupForm.smallClassId" />
  </div>
</template>

<script>
import { getGroupInfo, saveGroup, updateGroup } from "@/api/enrollment";
import { smallClassList } from "@/api/groupManage";
import BackButton from "@/components/backButton/index";
import { Confirm } from "@/components/Confirm";
import vue from "@/main";
import { CONVENE_CLASSES } from "@/utils/constants.js";
import Sortable from "sortablejs";
import Table from "./table.js";
import UserManage from "./userManage";

export default {
  components: { Table, UserManage, BackButton },
  data() {
    return {
      isConvene: false,
      leaderUserIds: [], // 组长或召集人id
      isSamllClass: 0,
      dragaable: false, //控制拖拽排序,
      titleMsg: "添加分组",
      classId: "",
      editId: null,
      onlyLook: false,
      groupForm: {
        groupName: "",
        leaderUserName: "",
        groupUserList: [],
        classPost: "",
        smallClassId: "",
      },
      pathOptions: {},
      checkArray: [],
      rules: {
        smallClassId: [
          {
            required: true,
            message: "请选择所属小班",
            trigger: ["blur", "change"],
          },
        ],
        groupName: [
          {
            required: true,
            message: "请输入班组名称",
            trigger: ["blur", "change"],
          },
          { min: 0, max: 50, message: "最多输入50个字", trigger: "change" },
        ],
        leaderUserName: [
          {
            required: true,
            message: "请选择班组组长",
            trigger: ["blur", "change"],
          },
          { min: 0, max: 50, message: "最多输入50个字", trigger: "change" },
        ],
        classPost: [
          {
            required: true,
            message: "请输入班内职务",
            trigger: ["change", "blur"],
          },
        ],
      },
      smallClassNameList: [],
    };
  },
  computed: {
    userIds() {
      return this.checkArray.map((item) => item.uuid);
    },
    dragDisabled() {
      if (this.groupForm.groupUserList.length < 2) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dragaable = false;
        return true;
      }
      return false;
    },
  },
  watch: {
    dragaable(val) {
      this.rowDrop(val);
    },
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if ( 
        from.path.indexOf("/offlineClass/groupList") != -1 || 
        from.path.indexOf("/onlineClass/groupList") != -1 ) {
        vm.pathOptions = {
          path: from.path,
          query: from.query
        }
      }
    });
  },

  created() {
    let { isSamllClass, classId, id, onlyLook, trainTypeName } =
      this.$route.query;
    this.isConvene = CONVENE_CLASSES.includes(trainTypeName);
    this.isSamllClass = Number(isSamllClass) || 0;
    this.classId = classId;
    this.editId = id;
    if (onlyLook) {
      this.onlyLook = true;
    }
    if (this.editId) {
      this.titleMsg = !!this.onlyLook ? "分组详情" : "编辑分组";
      this.getGroupInfo();
    }
    vue.$on("removeGroupUser", (item) => {
      this.removeGroupUser(item);
    });
    vue.$on("addGroupUsers", (groupUserList) => {
      this.addGroupUsers(groupUserList);
    });
    if (this.isSamllClass) {
      smallClassList({ classId: this.classId }).then(({ code, data }) => {
        if (code !== 0) return;
        this.smallClassNameList = data;
      });
    }
  },
  methods: {
    deleteLeaderUser(vo) {
      let { $index: index, row } = vo;
      let tempRow = JSON.parse(JSON.stringify(row));
      tempRow["groupPostName"] = "";
      this.groupForm.groupUserList.splice(index, 1, tempRow);
      let delIndex = this.leaderUserIds.indexOf(row.enrollId);
      if (delIndex !== -1) {
        this.leaderUserIds.splice(delIndex, 1);
      }
    },
    // 分组详情
    getGroupInfo() {
      getGroupInfo(this.editId).then((res) => {
        if (!res || res.code != 0) return;
        this.groupForm = res.data;
        this.leaderUserIds = res.data.leaderUserIds || [];
      });
    },
    addGroupUsers(groupUserList) {
      this.groupForm.groupUserList = groupUserList;
    },
    // 移除组员
    async removeGroupUser(item) {
      try {
        await Confirm(`确认移除该学员吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        let groupUserList = this.groupForm.groupUserList;
        groupUserList.splice(groupUserList.indexOf(item), 1);
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 设置组长
    setLeaderUser(vo) {
      let { $index: index, row } = vo;
      let tempRow = JSON.parse(JSON.stringify(row));
      if (row.groupPostName === "组长") return;
      if(!this.isConvene && this.editId) {
        let beforeIndex = this.groupForm.groupUserList.map(x => x.groupPostName).indexOf('组长');
        let beforeRow = JSON.parse(JSON.stringify(this.groupForm.groupUserList[beforeIndex]))
        beforeRow['groupPostName'] = ''
        this.groupForm.groupUserList.splice(beforeIndex, 1, beforeRow)
      }
      tempRow["groupPostName"] = this.isConvene ? "召集人" : "组长";
      this.groupForm.groupUserList.splice(index, 1, tempRow);
      if (this.isConvene) {
        this.leaderUserIds.push(row.enrollId);
      } else {
        let startIndex = this.groupForm.groupUserList
          .map((x) => x.enrollId)
          .indexOf(this.leaderUserIds[0]);
        if (startIndex !== -1) {
          let nowRow = JSON.parse(
            JSON.stringify(this.groupForm.groupUserList[startIndex])
          );
          nowRow["groupPostName"] = "";
          this.groupForm.groupUserList.splice(startIndex, 1, nowRow);
        }
        this.leaderUserIds = [row.enrollId];
      }
    },
    // 拖拽排序
    rowDrop(flag) {
      if (!flag) {
        // 关闭拖拽功能时销毁Sortable对象
        this.sort && this.sort.destroy();
      } else {
        const _this = this;
        const tbody = document.querySelector(".el-table__body-wrapper tbody");
        this.sort = Sortable.create(tbody, {
          animation: 180,
          delay: 0,
          sort: true,
          draggable: ".el-table__row",
          onEnd({ oldIndex, newIndex }) {
            const currRow = _this.groupForm.groupUserList.splice(
              oldIndex,
              1
            )[0];
            _this.groupForm.groupUserList.splice(newIndex, 0, currRow);
          },
        });
      }
    },
    // 班委管理
    groupUserManage() {
      if (this.isSamllClass == 1 && !this.groupForm.smallClassId) {
        this.$message.warning("请先选择所属小班！");
        return;
      }
      vue.$emit(
        "groupUserManage",
        this.$route.query.id,
        this.groupForm.groupUserList
      );
    },
    resetForm() {
      this.$refs["groupForm"].resetFields();
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    // 批量删除
    deleteGroupUsers() {
      this.$confirm(`确认批量移除选中的学员吗？`, "系统提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          for (let i = 0; i < this.checkArray.length; i++) {
            let groupUserList = this.groupForm.groupUserList;
            groupUserList.splice(this.checkArray[i], 1);
          }
        })
        .catch(() => {});
    },
    //更新分组
    submit() {
      if (this.leaderUserIds.length === 0) {
        this.$message.warning(`请设置${this.isConvene ? "召集人" : "组长"}`);
        return;
      }
      this.$refs["groupForm"].validate().then(() => {
        if (this.groupForm.groupUserList && this.groupForm.groupUserList) {
          this.groupForm.enrollIdList = this.groupForm.groupUserList.map(
            (item) => item.enrollId
          );
        } else {
          this.groupForm.enrollIdList = [];
        }
        let params = Object.assign({}, this.groupForm);
        params.classId = this.classId;
        params.isOnline = this.$route.query.isOnline;
        params.leaderUserIds = this.leaderUserIds;
        if (this.editId) {
          updateGroup(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "分组修改成功！",
              type: "success",
            });
            this.$router.push(this.pathOptions);
          });
        } else {
          saveGroup(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$message({
              message: "添加成功！",
              type: "success",
            });
            this.$router.push(this.pathOptions);
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.question-add {
  $textColor: #51627d;
  $textSize: 12px;
  @mixin text {
    color: $textColor;
    font-size: $textSize;
  }
  /deep/ .el-dialog__body {
    padding: 30px 30px 30px 20px;
  }
  .form {
    padding: 10px 20px;
  }
  .title {
    color: #343c4a;
    font-size: 16px;
    margin: 0;
    padding: 14px 0 10px 34px;
    border-bottom: 1px solid #edf1f8;
  }
  .delete-choose {
    position: absolute;
    top: 10px;
    right: -19px;
    font-size: 14px;
    cursor: pointer;
  }
  .form-select {
    width: 100%;
    &.has-btn {
      width: calc(100% - 120px);
    }
  }
  .mr16 {
    margin-right: 16px;
  }
}
.btn-div {
  float: right;
  /deep/ .drag-box {
    .el-checkbox__label {
      font-size: 12px;
      color: #51627d;
      font-weight: normal;
    }
  }
}
.dialog-footer {
  text-align: center;
}
.right-wrap {
  float: right;
  margin-bottom: 18px;
}
.select-content {
  width: 100% !important;
}
</style>
